import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import WarehouseForm from '../components/form/WarehouseForm';
import { IWarehouse } from '../types';
import { warehouseService } from '../api/warehouse.service';

const initWarehouse: IWarehouse = {
  id: null,
  code: '',
  description: '',
  laboratories: [],
  fiscal: true
};

export const CreateWarehouse = () => {
  const translationPrefix = 'pages.warehouse.new';

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createWarehouse = async (values) => {
    dispatch(loadingActions.startLoading());
    warehouseService.add(values).then((res) => {
      enqueueSnackbar('Magazzino aggiunto con successo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <WarehouseForm warehouse={initWarehouse} onSubmit={createWarehouse} />
    </TenantPage>
  );
};

export default CreateWarehouse;
